<h2 mat-dialog-title>Add Database User</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Username"
      placeholder="Type username"
      formControlName="username"
      type="text"
    ></app-input-field>

    <app-input-field
      label="Password"
      placeholder="Password"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Confirm Password"
      placeholder="Confirm Password"
      formControlName="passwordConf"
      type="password"
      [errorMessages]="{
        required: 'Confirm password is required',
        passwordMismatch: 'Passwords do not match',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add Database User</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
